export enum SaleStatus {
  BILLED = "BILLED",
  PENDING_COLLECTION = "PENDING_COLLECTION",
  CASHED = "CASHED",
  CASHED_IN_PROGRESS = "CASHED_IN_PROGRESS",
}